import {max} from 'lodash';
import moment from 'moment';
import {useCallback, useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {infoApi} from 'api';
import {InformationModal} from 'components';
import {DATE_FORMAT_SS} from 'constants/format';
import {UserContext} from 'context';
import {TRANSLATION_KEYS} from 'locale';
import {logger} from 'utils';

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.SYSTEM_DATE_VALIDATOR;

export const SystemDateValidator: React.FC = () => {
    const {t} = useTranslation();
    const [checked, setChecked] = useState(false);
    const [times, setTimes] = useState<{local: string, remote: string}>(null);
    const [modalOpen, setModalOpen] = useState(false);
    const {settings} = useContext(UserContext);

    const compareDates = useCallback(async () => {
        let isValid = false;
        const attempts = max([settings.common.systemDateValidation.attempts, 0]);
        for (let index = 0; index < attempts; index++) {
            if (isValid) {
                break;
            }
            try {
                const {ms} = await infoApi.getDate();
                const localMs = +new Date();
                setTimes({local: moment(localMs).format(DATE_FORMAT_SS), remote: moment(ms).format(DATE_FORMAT_SS)});
                const possibleDiffMs = settings.common.systemDateValidation.possibleDiff * 1000;
                if (ms + possibleDiffMs < localMs) {
                    logger.warn(`Invalid system date time. Attempt: ${index + 1}. Local: ` +
                    `${new Date(localMs).toISOString()}. Remote: ${new Date(ms).toISOString()}`);
                } else {
                    isValid = true;
                }
            } catch (error) {
                logger.error(`Unable to validate system date time. Attempt: ${index + 1}`, error);
            }
        }
        if (!isValid) {
            setModalOpen(true);
        }
    }, [settings]);

    useEffect(() => {
        if (!checked) {
            compareDates();
            setChecked(true);
        }
    }, [checked, compareDates]);

    return (
        <InformationModal
            open={modalOpen}
            title={t(T_KEYS.TITLE)}
            onClose={() => setModalOpen(false)}
        >
            <div>
                <div className='tw-mb-4'>{t(T_KEYS.INVALID_MSG)}</div>
                <div>{`${t(T_KEYS.LOCAL)}: ${times?.local}`}</div>
                <div className='tw-mb-4'>{`${t(T_KEYS.REMOTE)}: ${times?.remote}`}</div>
                <div>{t(T_KEYS.DESCRIPTION_MSG)}</div>
            </div>
        </InformationModal>
    );
};